const $ = require('jquery');

let classTabActive = 'tab--current',
    classTabContentActive = 'tab-panel--current';

// switch tabs on user interaction
$('.tabs .tab, .tabs-horizontal .tab').on('click', function () {
    let $tabs = $(this).closest('.tabs, .tabs-horizontal'),
        $tab = $(this);

    if (!$tab.hasClass(classTabActive)) {
        let tabID = $tab.data('tab-id');

        // clear all active tab classes
        $tabs.find('.tab').removeClass(classTabActive);
        // update tabs list
        $tabs.find('.tab[data-tab-id="' + tabID + '"]').addClass(classTabActive); // other tabs (like mobile tabs) with same ID
        // show tab-content
        $tabs.find('.tab-panel[data-tab-id="' + tabID + '"]').addClass(classTabContentActive).siblings().removeClass(classTabContentActive);

        window.location.hash = '#' + tabID;
    }
});

// init tabs
$('.tabs, .tabs-horizontal').each(function() {
    let currentTabID = window.location.hash || $('.tab', this).first().data('tab-id');

    currentTabID = currentTabID.replace('#', '');

    $('.tab[data-tab-id="' + currentTabID + '"]', this).trigger('click');
});


let $tabValidationErrorForm = $('.tab-panel .gform_wrapper.gform_validation_error');

// tigger tab switch when gravity forms validation error is present
if ($tabValidationErrorForm.length) {
    
    let currentTabID = $tabValidationErrorForm.closest('.tab-panel').data('tab-id');

    $('.tab[data-tab-id="' + currentTabID + '"]').trigger('click');

    // scroll to form
    $('html, body').animate({
        scrollTop: $('.tabs').offset().top
    }, 1000, 'easeInOutCubic', function() {
        $(this).blur();
    });
}